import React from 'react'
import {StyledDiv} from './StyledTypeDefinitions'
import styled from 'styled-components'

export const FlexContainer: StyledDiv = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  box-sizing: border-box;
`

export const RowFlexContainer = styled(FlexContainer)`
  flex-direction: row;
  align-items: center;
`

export const FullWidthRowFlexContainer = styled(RowFlexContainer)`
  width: 100%;
`

export const ColumnFlexContainer = styled(FlexContainer)`
  flex-direction: column;
  align-items: center;
`

export const FullWidthColumnFlexContainer = styled(ColumnFlexContainer)`
  width: 100%;
`

export const FlexStaticContent: StyledDiv = styled.div`
  flex: 0 1 auto;
`

export const FlexGrowContent: StyledDiv = styled.div`
  flex-shrink: 0;
  flex-basis: 0;
  flex-grow: 1;
`

export const FlexShrinkContent: StyledDiv = styled.div`
  flex-shrink: 1;
  flex-basis: 0;
  flex-grow: 1;
`

export const LeftRowFlexContainer = styled(RowFlexContainer)`
  justify-content: flex-start;
`

export const TopRowFlexContainer = styled(RowFlexContainer)`
  align-items: flex-start;
`

export const LeftTopRowFlexContainer = styled(LeftRowFlexContainer)`
  align-items: flex-start;
`

export const RightRowFlexContainer = styled(RowFlexContainer)`
  justify-content: flex-end;
`

export const CenterRowFlexContainer = styled(RowFlexContainer)`
  justify-content: center;
`

export const FullWidthLeftRowFlexContainer = styled(LeftRowFlexContainer)`
  width: 100%;
`

export const FullWidthRightRowFlexContainer = styled(RightRowFlexContainer)`
  width: 100%;
`

export const LeftColumnFlexContainer = styled(ColumnFlexContainer)`
  align-items: flex-start;
`

export const FullWidthLeftColumnFlexContainer = styled(LeftColumnFlexContainer)`
  width: 100%;
`

export const LeftTopColumnFlexContainer = styled(LeftColumnFlexContainer)`
  justify-content: flex-start;
`

export const RightColumnFlexContainer = styled(ColumnFlexContainer)`
  align-items: flex-end;
`

export const FullWidthRightColumnFlexContainer = styled(RightColumnFlexContainer)`
  width: 100%;
`

export const StretchRowFlexContainer = styled(FlexContainer)`
  flex-direction: row;
  align-items: stretch;
`

export const FlexStartRowFlexContainer = styled(FlexContainer)`
  flex-direction: row;
  align-items: flex-start;
`

export const LeftRowFlexWrapContainer = styled(RowFlexContainer)`
  justify-content: flex-start;
  flex-wrap: wrap;
`

export const StretchColumnFlexContainer = styled(FlexContainer)`
  flex-direction: column;
  align-items: stretch;
`

